<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="93.702"
    height="107.876"
    viewBox="0 0 93.702 107.876"
  >
    <g transform="translate(-65.365 -3136.315)">
      <g transform="translate(67.486 3138.253)">
        <g transform="translate(59.306 0) rotate(21)">
          <path class="a" d="M0,36.907V0" transform="translate(7.959 16.025)" />
          <circle
            class="a"
            cx="7.959"
            cy="7.959"
            r="7.959"
            transform="translate(0 0)"
          />
        </g>
        <g transform="translate(8.931 82.53) rotate(-106)">
          <path class="a" d="M0,11.536V0" transform="translate(4.276 8.433)" />
          <circle
            class="a"
            cx="4.183"
            cy="4.183"
            r="4.183"
            transform="translate(0 0)"
          />
        </g>
        <g transform="matrix(-0.326, -0.946, 0.946, -0.326, 58.948, 66.483)">
          <path class="a" d="M0,0V24.131" transform="translate(4.183 0)" />
          <circle
            class="a"
            cx="4.183"
            cy="4.183"
            r="4.183"
            transform="translate(0 24.131)"
          />
        </g>
        <g transform="translate(35.478 51.392) rotate(134)">
          <path class="a" d="M0,0V25.253" transform="translate(6.122 0)" />
          <circle
            class="a"
            cx="6.122"
            cy="6.122"
            r="6.122"
            transform="translate(0 25.253)"
          />
        </g>
        <g transform="translate(78.627 92.491) rotate(134)">
          <path class="a" d="M0,12.33V0" transform="translate(6.989 15.057)" />
          <circle
            class="a"
            cx="6.989"
            cy="6.989"
            r="6.989"
            transform="translate(0)"
          />
        </g>
        <g transform="translate(32.666 80.962) rotate(21)">
          <path class="a" d="M0,0V10.416" transform="translate(5.153 0)" />
          <circle
            class="a"
            cx="5.153"
            cy="5.153"
            r="5.153"
            transform="translate(0 10.416)"
          />
        </g>
      </g>
      <g class="a" transform="translate(95.125 3191.116)">
        <ellipse class="c" cx="14.744" cy="14.744" rx="14.744" ry="14.744" />
        <ellipse class="d" cx="14.744" cy="14.744" rx="16.244" ry="16.244" />
      </g>
      <g transform="translate(102.278 3195.558)">
        <g transform="translate(3.253)">
          <ellipse class="people" cx="4.337" cy="4.337" rx="4.337" ry="4.337" />
        </g>
        <path
          class="people"
          d="M528.325,325.274a7.558,7.558,0,0,1,7.68-7.58,7.655,7.655,0,0,1,7.482,7.7v.979c0,1.2-3.4,2.169-7.59,2.169s-7.59-.971-7.59-2.169Z"
          transform="translate(-528.307 -307.934)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style>
.a,
.d {
  fill: none;
}
.a {
  stroke: #fff;
  stroke-width: 3px;
}
.people {
  transition: fill 0.2s linear;
  fill: #ffdf22;
}
.c {
  stroke: none;
}
</style>
